import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSangre/addControlSangre`, method: 'POST', body: values, token: token})
}
